export const HydraBoostDailyFixture = {
  id: 1,
  title: 'Hydra Boost Daily Lenses',
  handle: 'daily-lenses',
  description:
    'Designed for optimum comfort and moisture. Each lens is made from ultra-breathable Etafilcon A with a high water content of 58%.',
  productVariants: [
    {
      id: 1,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-0-50',
      label: null,
      description: null,
      assets: [
        {
          asset: {
            id: 1,
            path: '/images/products/original-lens/subscription-lens-blister.png',
          },
        },
      ],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.50',
            value: '-0.50',
            id: 1,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 1,
          region: 'US',
          sku: 'WALBASE-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 2,
          region: 'UK',
          sku: 'WALBASE-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 3,
          region: 'SE',
          sku: 'WALBASE-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 4,
          region: 'EU',
          sku: 'WALBASE-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 2,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.75',
            value: '-0.75',
            id: 2,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 5,
          region: 'US',
          sku: 'WALBASE-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 6,
          region: 'UK',
          sku: 'WALBASE-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 7,
          region: 'SE',
          sku: 'WALBASE-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 8,
          region: 'EU',
          sku: 'WALBASE-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 3,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.00',
            value: '-1.00',
            id: 3,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 9,
          region: 'US',
          sku: 'WALBASE-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 10,
          region: 'UK',
          sku: 'WALBASE-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 11,
          region: 'SE',
          sku: 'WALBASE-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 12,
          region: 'EU',
          sku: 'WALBASE-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 4,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.25',
            value: '-1.25',
            id: 4,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 13,
          region: 'US',
          sku: 'WALBASE-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 14,
          region: 'UK',
          sku: 'WALBASE-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 15,
          region: 'SE',
          sku: 'WALBASE-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 16,
          region: 'EU',
          sku: 'WALBASE-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 5,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.50',
            value: '-1.50',
            id: 5,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 17,
          region: 'US',
          sku: 'WALBASE-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 18,
          region: 'UK',
          sku: 'WALBASE-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 19,
          region: 'SE',
          sku: 'WALBASE-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 20,
          region: 'EU',
          sku: 'WALBASE-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 6,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.75',
            value: '-1.75',
            id: 6,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 21,
          region: 'US',
          sku: 'WALBASE-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 22,
          region: 'UK',
          sku: 'WALBASE-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 23,
          region: 'SE',
          sku: 'WALBASE-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 24,
          region: 'EU',
          sku: 'WALBASE-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 7,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.00',
            value: '-2.00',
            id: 7,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 25,
          region: 'US',
          sku: 'WALBASE-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 26,
          region: 'UK',
          sku: 'WALBASE-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 27,
          region: 'SE',
          sku: 'WALBASE-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 28,
          region: 'EU',
          sku: 'WALBASE-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 8,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.25',
            value: '-2.25',
            id: 8,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 29,
          region: 'US',
          sku: 'WALBASE-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 30,
          region: 'UK',
          sku: 'WALBASE-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 31,
          region: 'SE',
          sku: 'WALBASE-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 32,
          region: 'EU',
          sku: 'WALBASE-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 9,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.50',
            value: '-2.50',
            id: 9,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 33,
          region: 'US',
          sku: 'WALBASE-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 34,
          region: 'UK',
          sku: 'WALBASE-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 35,
          region: 'SE',
          sku: 'WALBASE-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 36,
          region: 'EU',
          sku: 'WALBASE-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 10,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.75',
            value: '-2.75',
            id: 10,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 37,
          region: 'US',
          sku: 'WALBASE-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 38,
          region: 'UK',
          sku: 'WALBASE-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 39,
          region: 'SE',
          sku: 'WALBASE-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 40,
          region: 'EU',
          sku: 'WALBASE-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 11,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.00',
            value: '-3.00',
            id: 11,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 41,
          region: 'US',
          sku: 'WALBASE-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 42,
          region: 'UK',
          sku: 'WALBASE-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 43,
          region: 'SE',
          sku: 'WALBASE-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 44,
          region: 'EU',
          sku: 'WALBASE-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 12,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.25',
            value: '-3.25',
            id: 12,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 45,
          region: 'US',
          sku: 'WALBASE-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 46,
          region: 'UK',
          sku: 'WALBASE-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 47,
          region: 'SE',
          sku: 'WALBASE-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 48,
          region: 'EU',
          sku: 'WALBASE-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 13,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.50',
            value: '-3.50',
            id: 13,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 49,
          region: 'US',
          sku: 'WALBASE-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 50,
          region: 'UK',
          sku: 'WALBASE-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 51,
          region: 'SE',
          sku: 'WALBASE-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 52,
          region: 'EU',
          sku: 'WALBASE-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 14,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.75',
            value: '-3.75',
            id: 14,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 53,
          region: 'US',
          sku: 'WALBASE-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 54,
          region: 'UK',
          sku: 'WALBASE-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 55,
          region: 'SE',
          sku: 'WALBASE-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 56,
          region: 'EU',
          sku: 'WALBASE-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 15,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.00',
            value: '-4.00',
            id: 15,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 57,
          region: 'US',
          sku: 'WALBASE-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 58,
          region: 'UK',
          sku: 'WALBASE-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 59,
          region: 'SE',
          sku: 'WALBASE-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 60,
          region: 'EU',
          sku: 'WALBASE-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 16,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-4-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.25',
            value: '-4.25',
            id: 16,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 61,
          region: 'US',
          sku: 'WALBASE-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 62,
          region: 'UK',
          sku: 'WALBASE-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 63,
          region: 'SE',
          sku: 'WALBASE-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 64,
          region: 'EU',
          sku: 'WALBASE-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 17,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-4-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.50',
            value: '-4.50',
            id: 17,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 65,
          region: 'US',
          sku: 'WALBASE-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 66,
          region: 'UK',
          sku: 'WALBASE-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 67,
          region: 'SE',
          sku: 'WALBASE-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 68,
          region: 'EU',
          sku: 'WALBASE-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 18,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-4-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.75',
            value: '-4.75',
            id: 18,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 69,
          region: 'US',
          sku: 'WALBASE-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 70,
          region: 'UK',
          sku: 'WALBASE-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 71,
          region: 'SE',
          sku: 'WALBASE-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 72,
          region: 'EU',
          sku: 'WALBASE-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 19,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-5-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.00',
            value: '-5.00',
            id: 19,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 73,
          region: 'US',
          sku: 'WALBASE-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 74,
          region: 'UK',
          sku: 'WALBASE-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 75,
          region: 'SE',
          sku: 'WALBASE-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 76,
          region: 'EU',
          sku: 'WALBASE-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 20,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-5-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.25',
            value: '-5.25',
            id: 20,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 77,
          region: 'US',
          sku: 'WALBASE-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 78,
          region: 'UK',
          sku: 'WALBASE-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 79,
          region: 'SE',
          sku: 'WALBASE-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 80,
          region: 'EU',
          sku: 'WALBASE-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 21,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-5-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.50',
            value: '-5.50',
            id: 21,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 81,
          region: 'US',
          sku: 'WALBASE-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 82,
          region: 'UK',
          sku: 'WALBASE-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 83,
          region: 'SE',
          sku: 'WALBASE-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 84,
          region: 'EU',
          sku: 'WALBASE-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 22,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-5-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.75',
            value: '-5.75',
            id: 22,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 85,
          region: 'US',
          sku: 'WALBASE-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 86,
          region: 'UK',
          sku: 'WALBASE-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 87,
          region: 'SE',
          sku: 'WALBASE-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 88,
          region: 'EU',
          sku: 'WALBASE-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 23,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-6-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.00',
            value: '-6.00',
            id: 23,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 89,
          region: 'US',
          sku: 'WALBASE-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 90,
          region: 'UK',
          sku: 'WALBASE-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 91,
          region: 'SE',
          sku: 'WALBASE-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 92,
          region: 'EU',
          sku: 'WALBASE-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 24,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-6-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.50',
            value: '-6.50',
            id: 24,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 93,
          region: 'US',
          sku: 'WALBASE-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 94,
          region: 'UK',
          sku: 'WALBASE-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 95,
          region: 'SE',
          sku: 'WALBASE-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 96,
          region: 'EU',
          sku: 'WALBASE-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 25,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-7-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.00',
            value: '-7.00',
            id: 25,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 97,
          region: 'US',
          sku: 'WALBASE-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 98,
          region: 'UK',
          sku: 'WALBASE-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 99,
          region: 'SE',
          sku: 'WALBASE-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 100,
          region: 'EU',
          sku: 'WALBASE-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 26,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-7-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.50',
            value: '-7.50',
            id: 26,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 101,
          region: 'US',
          sku: 'WALBASE-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 102,
          region: 'UK',
          sku: 'WALBASE-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 103,
          region: 'SE',
          sku: 'WALBASE-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 104,
          region: 'EU',
          sku: 'WALBASE-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 27,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-8-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.00',
            value: '-8.00',
            id: 27,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 105,
          region: 'US',
          sku: 'WALBASE-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 106,
          region: 'UK',
          sku: 'WALBASE-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 107,
          region: 'SE',
          sku: 'WALBASE-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 108,
          region: 'EU',
          sku: 'WALBASE-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 28,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-8-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.50',
            value: '-8.50',
            id: 28,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 109,
          region: 'US',
          sku: 'WALBASE-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 110,
          region: 'UK',
          sku: 'WALBASE-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 111,
          region: 'SE',
          sku: 'WALBASE-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 112,
          region: 'EU',
          sku: 'WALBASE-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 29,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-9-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.00',
            value: '-9.00',
            id: 29,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 113,
          region: 'US',
          sku: 'WALBASE-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 114,
          region: 'UK',
          sku: 'WALBASE-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 115,
          region: 'SE',
          sku: 'WALBASE-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 116,
          region: 'EU',
          sku: 'WALBASE-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 30,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-9-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.50',
            value: '-9.50',
            id: 30,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 117,
          region: 'US',
          sku: 'WALBASE-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 118,
          region: 'UK',
          sku: 'WALBASE-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 119,
          region: 'SE',
          sku: 'WALBASE-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 120,
          region: 'EU',
          sku: 'WALBASE-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 31,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-10-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.00',
            value: '-10.00',
            id: 31,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 121,
          region: 'US',
          sku: 'WALBASE-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 122,
          region: 'UK',
          sku: 'WALBASE-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 123,
          region: 'SE',
          sku: 'WALBASE-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 124,
          region: 'EU',
          sku: 'WALBASE-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 32,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-10-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.50',
            value: '-10.50',
            id: 32,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 125,
          region: 'US',
          sku: 'WALBASE-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 126,
          region: 'UK',
          sku: 'WALBASE-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 127,
          region: 'SE',
          sku: 'WALBASE-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 128,
          region: 'EU',
          sku: 'WALBASE-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 33,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-11-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.00',
            value: '-11.00',
            id: 33,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 129,
          region: 'US',
          sku: 'WALBASE-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 130,
          region: 'UK',
          sku: 'WALBASE-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 131,
          region: 'SE',
          sku: 'WALBASE-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 132,
          region: 'EU',
          sku: 'WALBASE-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 34,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-11-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.50',
            value: '-11.50',
            id: 34,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 133,
          region: 'US',
          sku: 'WALBASE-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 134,
          region: 'UK',
          sku: 'WALBASE-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 135,
          region: 'SE',
          sku: 'WALBASE-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 136,
          region: 'EU',
          sku: 'WALBASE-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 35,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-negative-12-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -12.00',
            value: '-12.00',
            id: 35,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 137,
          region: 'US',
          sku: 'WALBASE-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 138,
          region: 'UK',
          sku: 'WALBASE-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 139,
          region: 'SE',
          sku: 'WALBASE-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 140,
          region: 'EU',
          sku: 'WALBASE-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 36,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-0-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.50',
            value: '+0.50',
            id: 36,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 141,
          region: 'US',
          sku: 'WALBASE+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 142,
          region: 'UK',
          sku: 'WALBASE+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 143,
          region: 'SE',
          sku: 'WALBASE+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 144,
          region: 'EU',
          sku: 'WALBASE+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 37,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.75',
            value: '+0.75',
            id: 37,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 145,
          region: 'US',
          sku: 'WALBASE+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 146,
          region: 'UK',
          sku: 'WALBASE+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 147,
          region: 'SE',
          sku: 'WALBASE+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 148,
          region: 'EU',
          sku: 'WALBASE+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 38,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.00',
            value: '+1.00',
            id: 38,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 149,
          region: 'US',
          sku: 'WALBASE+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 150,
          region: 'UK',
          sku: 'WALBASE+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 151,
          region: 'SE',
          sku: 'WALBASE+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 152,
          region: 'EU',
          sku: 'WALBASE+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 39,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.25',
            value: '+1.25',
            id: 39,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 153,
          region: 'US',
          sku: 'WALBASE+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 154,
          region: 'UK',
          sku: 'WALBASE+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 155,
          region: 'SE',
          sku: 'WALBASE+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 156,
          region: 'EU',
          sku: 'WALBASE+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 40,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.50',
            value: '+1.50',
            id: 40,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 157,
          region: 'US',
          sku: 'WALBASE+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 158,
          region: 'UK',
          sku: 'WALBASE+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 159,
          region: 'SE',
          sku: 'WALBASE+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 160,
          region: 'EU',
          sku: 'WALBASE+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 41,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.75',
            value: '+1.75',
            id: 41,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 161,
          region: 'US',
          sku: 'WALBASE+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 162,
          region: 'UK',
          sku: 'WALBASE+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 163,
          region: 'SE',
          sku: 'WALBASE+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 164,
          region: 'EU',
          sku: 'WALBASE+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 42,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.00',
            value: '+2.00',
            id: 42,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 165,
          region: 'US',
          sku: 'WALBASE+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 166,
          region: 'UK',
          sku: 'WALBASE+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 167,
          region: 'SE',
          sku: 'WALBASE+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 168,
          region: 'EU',
          sku: 'WALBASE+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 43,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.25',
            value: '+2.25',
            id: 43,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 169,
          region: 'US',
          sku: 'WALBASE+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 170,
          region: 'UK',
          sku: 'WALBASE+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 171,
          region: 'SE',
          sku: 'WALBASE+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 172,
          region: 'EU',
          sku: 'WALBASE+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 44,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.50',
            value: '+2.50',
            id: 44,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 173,
          region: 'US',
          sku: 'WALBASE+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 174,
          region: 'UK',
          sku: 'WALBASE+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 175,
          region: 'SE',
          sku: 'WALBASE+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 176,
          region: 'EU',
          sku: 'WALBASE+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 45,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.75',
            value: '+2.75',
            id: 45,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 177,
          region: 'US',
          sku: 'WALBASE+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 178,
          region: 'UK',
          sku: 'WALBASE+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 179,
          region: 'SE',
          sku: 'WALBASE+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 180,
          region: 'EU',
          sku: 'WALBASE+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 46,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.00',
            value: '+3.00',
            id: 46,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 181,
          region: 'US',
          sku: 'WALBASE+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 182,
          region: 'UK',
          sku: 'WALBASE+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 183,
          region: 'SE',
          sku: 'WALBASE+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 184,
          region: 'EU',
          sku: 'WALBASE+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 47,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.25',
            value: '+3.25',
            id: 47,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 185,
          region: 'US',
          sku: 'WALBASE+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 186,
          region: 'UK',
          sku: 'WALBASE+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 187,
          region: 'SE',
          sku: 'WALBASE+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 188,
          region: 'EU',
          sku: 'WALBASE+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 48,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.50',
            value: '+3.50',
            id: 48,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 189,
          region: 'US',
          sku: 'WALBASE+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 190,
          region: 'UK',
          sku: 'WALBASE+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 191,
          region: 'SE',
          sku: 'WALBASE+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 192,
          region: 'EU',
          sku: 'WALBASE+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 49,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.75',
            value: '+3.75',
            id: 49,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 193,
          region: 'US',
          sku: 'WALBASE+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 194,
          region: 'UK',
          sku: 'WALBASE+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 195,
          region: 'SE',
          sku: 'WALBASE+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 196,
          region: 'EU',
          sku: 'WALBASE+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 50,
      title: 'Hydra Boost Daily Lenses',
      handle: 'daily-lenses-positive-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +4.00',
            value: '+4.00',
            id: 50,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 197,
          region: 'US',
          sku: 'WALBASE+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4900,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 12000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 22600,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 43000,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 198,
          region: 'UK',
          sku: 'WALBASE+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 3000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 6800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 12800,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 25200,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 199,
          region: 'SE',
          sku: 'WALBASE+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 200,
          region: 'EU',
          sku: 'WALBASE+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 36400,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 82000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 154000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 300000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
  ],
};
